var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-feature-tag has-tooltip-top has-tooltip-multiline",attrs:{"data-tooltip":_vm.text}},[_vm._v(" New ")])
}
var staticRenderFns = []

export { render, staticRenderFns }